import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CanActivate } from '@angular/router';

export const EASYSURE_PRODUCTS_URL = 'https://ssp.easysure.dk/products?accept-language=da&kpcid=20000131';

// NEXT bliver til easySure - price calculation is no longer possible here, so the customer is sent to easySure instead
@Injectable({ providedIn: 'root' })
export class CalculationDisabledGuard implements CanActivate {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    canActivate() {
        this.document.location.href = EASYSURE_PRODUCTS_URL;
        return false;
    }
}
